// @ts-nocheck
import React from 'react';
import { sx } from '../sx';
import CohortToolbar from './CohortToolbar';
import CohortGrid from './CohortGrid';
import CohortForecastRow from './CohortForecastRow';
import CohortFlagsPanel from './CohortFlagsPanel';
import CohortReviewCard from './CohortReviewCard';

export default function CohortScreen({ vm }: { vm: any }) {
	if (!vm.showCohorts) {
		return null;
	}
	return (
		<>
			<CohortToolbar vm={vm} />
			<CohortForecastRow f={vm.forecastRow} />
			<div style={sx(`flex:1;min-height:0;display:flex;position:relative`)}>
				<div style={sx(`flex:1;min-width:0;display:flex;flex-direction:column`)}>
					<CohortGrid vm={vm} />
				</div>
				<CohortFlagsPanel p={vm.flagPanel} />
				{vm.reviewCard ? <CohortReviewCard key={vm.reviewCard.title} r={vm.reviewCard} /> : null}
			</div>
		</>
	);
}
